<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Carnet', route: '/backoffice/carnet/' }, { label: 'Aggiungi Carnet', route: '/backoffice/carnet/add' }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formCarnet" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <h2>Dati carnet</h2>
            <span class="ac-meta">titolo e descrizione per ogni voce</span>
        </div>

        <div class="grid gap-6" [ngClass]="{'grid-cols-1': carnet_items.length == 1, 'lg:grid-cols-2 grid-cols-1': carnet_items.length == 2, 'lg:grid-cols-3 md:grid-cols-2': carnet_items.length >= 3}">
            <div *ngFor="let contenuto of carnet_items; let i = index" class="flex flex-col gap-4 w-full">
                <div class="fld">
                    <label>* Titolo</label>
                    <input type="text" pInputText class="w-full" placeholder="Titolo" [formControlName]="'titolo_' + i" />
                    <small class="text-red-600 block mt-2 font-medium" *ngIf="formCarnet.get('titolo_' + i)?.hasError('required') && (formCarnet.get('titolo_' + i)?.dirty || formCarnet.get('titolo_' + i)?.touched)">Il titolo è obbligatorio.</small>
                </div>
                <div class="fld">
                    <label>Descrizione</label>
                    <p-editor [style]="{ height: '150px' }" [formControlName]="'descrizione_' + i" />
                </div>
                <div class="flex justify-end" *ngIf="carnet_items.length !== 1">
                    <button class="acc-btn acc-btn-ghost" type="button" (click)="onRemoveItem(i)">Rimuovi dato</button>
                </div>
            </div>
        </div>

        <div class="acc-actions">
            <button class="acc-btn" type="button" (click)="onAddItem()">Aggiungi un dato</button>
            <a class="acc-btn acc-btn-ghost" routerLink="/backoffice/carnet">Annulla</a>
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formCarnet.valid">Aggiungi carnet</button>
        </div>
    </form>
</section>
